import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _58164725 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _be95cf7c = () => interopDefault(import('..\\pages\\business\\index.vue' /* webpackChunkName: "pages/business/index" */))
const _88175788 = () => interopDefault(import('..\\pages\\cahandle\\index.vue' /* webpackChunkName: "pages/cahandle/index" */))
const _3173427a = () => interopDefault(import('..\\pages\\download\\index.vue' /* webpackChunkName: "pages/download/index" */))
const _9108f754 = () => interopDefault(import('..\\pages\\guide\\index.vue' /* webpackChunkName: "pages/guide/index" */))
const _2e42b9c9 = () => interopDefault(import('..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _6228ff4f = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _5bde9054 = () => interopDefault(import('..\\pages\\outside-cjwt\\index.vue' /* webpackChunkName: "pages/outside-cjwt/index" */))
const _54b28d7f = () => interopDefault(import('..\\pages\\register\\index.vue' /* webpackChunkName: "pages/register/index" */))
const _0e40ff91 = () => interopDefault(import('..\\pages\\business\\detail.vue' /* webpackChunkName: "pages/business/detail" */))
const _fa3e0186 = () => interopDefault(import('..\\pages\\business\\detail-sd.vue' /* webpackChunkName: "pages/business/detail-sd" */))
const _0ff5d77a = () => interopDefault(import('..\\pages\\business\\index copy.vue' /* webpackChunkName: "pages/business/index copy" */))
const _66a23dc4 = () => interopDefault(import('..\\pages\\login\\index-zfcg.vue' /* webpackChunkName: "pages/login/index-zfcg" */))
const _7b49fa24 = () => interopDefault(import('..\\pages\\news\\detail.vue' /* webpackChunkName: "pages/news/detail" */))
const _5f00115a = () => interopDefault(import('..\\pages\\business\\components\\file-download.vue' /* webpackChunkName: "pages/business/components/file-download" */))
const _501b77cf = () => interopDefault(import('..\\pages\\business\\components\\link-paper.vue' /* webpackChunkName: "pages/business/components/link-paper" */))
const _518e05c4 = () => interopDefault(import('..\\pages\\business\\components\\search-bar.vue' /* webpackChunkName: "pages/business/components/search-bar" */))
const _588e4801 = () => interopDefault(import('..\\pages\\business\\components\\search-bar copy.vue' /* webpackChunkName: "pages/business/components/search-bar copy" */))
const _45c7bbae = () => interopDefault(import('..\\pages\\business\\components\\table-hxrgs.vue' /* webpackChunkName: "pages/business/components/table-hxrgs" */))
const _2c68e1dc = () => interopDefault(import('..\\pages\\register\\components\\btn-yzm.vue' /* webpackChunkName: "pages/register/components/btn-yzm" */))
const _abe080de = () => interopDefault(import('..\\pages\\register\\components\\captcha.vue' /* webpackChunkName: "pages/register/components/captcha" */))
const _9a679280 = () => interopDefault(import('..\\pages\\register\\components\\input-yzm.vue' /* webpackChunkName: "pages/register/components/input-yzm" */))
const _03ae1222 = () => interopDefault(import('..\\pages\\register\\components\\tos.vue' /* webpackChunkName: "pages/register/components/tos" */))
const _463a4982 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _4e55ac5c = () => interopDefault(import('..\\pages\\index\\sections\\banner.vue' /* webpackChunkName: "pages/index/sections/banner" */))
const _037e8620 = () => interopDefault(import('..\\pages\\index\\sections\\business.vue' /* webpackChunkName: "pages/index/sections/business" */))
const _5c17b24b = () => interopDefault(import('..\\pages\\index\\sections\\enters.vue' /* webpackChunkName: "pages/index/sections/enters" */))
const _2853be98 = () => interopDefault(import('..\\pages\\index\\sections\\footlink.vue' /* webpackChunkName: "pages/index/sections/footlink" */))
const _24b47c5a = () => interopDefault(import('..\\pages\\index\\sections\\logins.vue' /* webpackChunkName: "pages/index/sections/logins" */))
const _77aa5afa = () => interopDefault(import('..\\pages\\index\\sections\\news.vue' /* webpackChunkName: "pages/index/sections/news" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _58164725,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/business",
    component: _be95cf7c,
    alias: "/business/index.html",
    name: "business"
  }, {
    path: "/cahandle",
    component: _88175788,
    alias: "/cahandle/index.html",
    name: "cahandle"
  }, {
    path: "/download",
    component: _3173427a,
    alias: "/download/index.html",
    name: "download"
  }, {
    path: "/guide",
    component: _9108f754,
    alias: "/guide/index.html",
    name: "guide"
  }, {
    path: "/login",
    component: _2e42b9c9,
    alias: "/login/index.html",
    name: "login"
  }, {
    path: "/news",
    component: _6228ff4f,
    alias: "/news/index.html",
    name: "news"
  }, {
    path: "/outside-cjwt",
    component: _5bde9054,
    alias: "/outside-cjwt/index.html",
    name: "outside-cjwt"
  }, {
    path: "/register",
    component: _54b28d7f,
    alias: "/register/index.html",
    name: "register"
  }, {
    path: "/business/detail",
    component: _0e40ff91,
    alias: "/business/detail/index.html",
    name: "business-detail"
  }, {
    path: "/business/detail-sd",
    component: _fa3e0186,
    alias: "/business/detail-sd/index.html",
    name: "business-detail-sd"
  }, {
    path: "/business/index%20copy",
    component: _0ff5d77a,
    alias: "/business/index%20copy/index.html",
    name: "business-index copy"
  }, {
    path: "/login/index-zfcg",
    component: _66a23dc4,
    alias: "/login/index-zfcg/index.html",
    name: "login-index-zfcg"
  }, {
    path: "/news/detail",
    component: _7b49fa24,
    alias: "/news/detail/index.html",
    name: "news-detail"
  }, {
    path: "/business/components/file-download",
    component: _5f00115a,
    alias: "/business/components/file-download/index.html",
    name: "business-components-file-download"
  }, {
    path: "/business/components/link-paper",
    component: _501b77cf,
    alias: "/business/components/link-paper/index.html",
    name: "business-components-link-paper"
  }, {
    path: "/business/components/search-bar",
    component: _518e05c4,
    alias: "/business/components/search-bar/index.html",
    name: "business-components-search-bar"
  }, {
    path: "/business/components/search-bar%20copy",
    component: _588e4801,
    alias: "/business/components/search-bar%20copy/index.html",
    name: "business-components-search-bar copy"
  }, {
    path: "/business/components/table-hxrgs",
    component: _45c7bbae,
    alias: "/business/components/table-hxrgs/index.html",
    name: "business-components-table-hxrgs"
  }, {
    path: "/register/components/btn-yzm",
    component: _2c68e1dc,
    alias: "/register/components/btn-yzm/index.html",
    name: "register-components-btn-yzm"
  }, {
    path: "/register/components/captcha",
    component: _abe080de,
    alias: "/register/components/captcha/index.html",
    name: "register-components-captcha"
  }, {
    path: "/register/components/input-yzm",
    component: _9a679280,
    alias: "/register/components/input-yzm/index.html",
    name: "register-components-input-yzm"
  }, {
    path: "/register/components/tos",
    component: _03ae1222,
    alias: "/register/components/tos/index.html",
    name: "register-components-tos"
  }, {
    path: "/",
    component: _463a4982,
    alias: "/index.html",
    name: "index",
    children: [{
      path: "sections/banner",
      component: _4e55ac5c,
      name: "index-sections-banner"
    }, {
      path: "sections/business",
      component: _037e8620,
      name: "index-sections-business"
    }, {
      path: "sections/enters",
      component: _5c17b24b,
      name: "index-sections-enters"
    }, {
      path: "sections/footlink",
      component: _2853be98,
      name: "index-sections-footlink"
    }, {
      path: "sections/logins",
      component: _24b47c5a,
      name: "index-sections-logins"
    }, {
      path: "sections/news",
      component: _77aa5afa,
      name: "index-sections-news"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
